import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

export const StyledCrmIndustryTransitionAlertBanner = styled(Flex)`
    width: 100%;
    margin-bottom: 24px;
    padding: 8px 16px;
    border-radius: 3px;
    background-color: ${colorsPalettes.bluegrey["200"]};
`;

export const StyledCrmIndustryTransitionAlertBannerIcon = styled(Flex)`
    margin-right: 8px;
    flex-shrink: 0;
`;
